import React from 'react';

// A {lead, rest} filter summary as the FilterBar line: "Showing <b>lead</b>rest".
export const summary_line = (s) =>
  s ? (
    <>
      Showing <b>{s.lead}</b>
      {s.rest}
    </>
  ) : null;
